import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import globalReducer from "./reducers/global";
import storage from "redux-persist/lib/storage";
import cartSlice from "./reducers/cart-slice";

const reducers = combineReducers({
  global: globalReducer,
  cart: cartSlice,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["global", "cart"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
